import {
  CornerRadiusModel,
  DrawingShape,
  getCornerRadiusProductIdFromSize,
} from '~/core/models';
import { incById } from '~/core/utils';

export const getCornersCounts = (
  drawingShapes: DrawingShape[],
  cornerRadii: CornerRadiusModel[],
  defaultOptionProductId?: number
) =>
  drawingShapes.reduce<Record<number, number>>(
    (acc, shape) =>
      Object.values(shape.cornerMap).reduce(
        (counter, corner) =>
          incById(
            counter,
            corner.isVisibleInCanvas &&
              corner.size &&
              (getCornerRadiusProductIdFromSize(corner.size, cornerRadii) ??
                defaultOptionProductId)
          ),
        acc
      ),
    {}
  );
